import React, { FC, ReactElement } from 'react';

type EmptyStateProps = {
  message: string;
  icon?: string;
  className?: string;
};

const EmptyState: FC<EmptyStateProps> = ({ message, icon = 'fas fa-inbox', className = '' }: EmptyStateProps): ReactElement => {
  return (
    <div
      className={`d-flex flex-column align-items-center justify-content-center text-center text-muted rounded-3 px-3 py-4 gap-2 ${className}`}
      style={{ border: '1px dashed #e2e8f0', backgroundColor: '#fafafb' }}
    >
      <i className={`${icon} fs-4 opacity-50`} aria-hidden="true" />
      <p className="mb-0 small">{message}</p>
    </div>
  );
};

export default EmptyState;
